export default __webpack_public_path__ + "static/media/teisslL.11101b06.jpg";